import React from "react";
import { useState, useEffect } from "react";

import Navbar from "./Navbar";

import "./Contact.css";

import axios from "axios";

const changeLink = () => {
  const links = document.querySelectorAll(".nav-item a");
  links.forEach((link) => {
    if (link.classList.contains("active")) {
      link.classList.remove("active");
    }
    if (link.innerHTML === "Contact Us") {
      link.classList.add("active");
    }
  });
};

const Contact2 = () => {
  const [data, setData] = useState({
    firstname: "",
    lastname: "",
    email: "",
    number: "",
    message: "",
  });

  useEffect(() => {
    changeLink();
  }, []);

  const handleChange = (e) => {
    const value = e.target.value;
    setData({
      ...data,
      [e.target.name]: value,
    });
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    const userData = {
      firstname: data.firstname,
      lastname: data.lastname,
      email: data.email,
      number: data.number,
      message: data.message,
    };

    axios
      .post(`${process.env.REACT_APP_SERVER_URL}/send/contactus`, userData)
      .then((response) => {
        console.log(response.status);
        console.log(response.data);
      });
    setData({
      firstname: "",
      lastname: "",
      email: "",
      number: "",
      message: "",
    });
    window.alert("Are you sure?");
  };

  return (
    <>
      <Navbar />
      <div className="contact flex">
        <div className="contact-cont">
          <div className="info">
            <h3>Contact info</h3>
            <p>
              <h5>Registered Office</h5>
              <i className="fa-solid fa-location-dot"></i> Fyzen Career
              Solutions Private Limited, 090/LT-1 (B), Tambri Osmanabad,
              Maharashtra – 413501, India.
            </p>
            <br />
            <p>
              <h5>Correspondence Address</h5>
              <i className="fa-solid fa-location-dot"></i> Utsav Bhardwaj, The
              University of Queensland – IIT Delhi Academy of Research (UQIDAR),
              Indian Institute of Technology Delhi, New Delhi, Delhi – 110016,
              India.
            </p>
            <br />
            <p>
              <i className="fa-solid fa-envelope"></i> support@interwiu.com
            </p>
            <p>
              <i className="fa-solid fa-phone"></i> +91-9176583479
            </p>
            <div className="info-socials">
              <i className="fa-brands fa-facebook-f"></i>
              {/* <i className="fa-brands fa-twitter"></i> */}
              <i className="fa-brands fa-instagram"></i>
              {/* <i className="fa-brands fa-pinterest-p"></i> */}
              <i className="fa-brands fa-linkedin"></i>
            </div>
          </div>
          <div className="message">
            <form onSubmit={handleSubmit} method="POST">
              <h2>Send a Message</h2>
              <div className="name flex">
                <div className="first-name">
                  <label htmlFor="first_name">First Name</label>
                  <input
                    type="text"
                    placeholder="First Name"
                    name="firstname"
                    value={data.firstname}
                    onChange={handleChange}
                  />
                </div>
                <div className="last-name">
                  <label htmlFor="last_name">Last Name</label>
                  <input
                    type="text"
                    name="lastname"
                    placeholder="Last Name"
                    value={data.lastname}
                    onChange={handleChange}
                  />
                </div>
              </div>
              <div className="email flex">
                <input
                  type="email"
                  placeholder="Email"
                  name="email"
                  value={data.email}
                  onChange={handleChange}
                />
                <input
                  type="number"
                  placeholder="Number"
                  name="number"
                  value={data.number}
                  onChange={handleChange}
                />
              </div>
              <textarea
                name="message"
                id="message"
                placeholder="Write your message here..."
                value={data.message}
                onChange={handleChange}
              ></textarea>
              <button className="cust-btn send-btn">Send</button>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default Contact2;
